import gql from 'graphql-tag';

export const GET_DISTRIBUTION_TOKEN = gql`
  mutation createDistributionOneTimeToken($organizationId: String!) {
    createDistributionOneTimeToken(organization_id: $organizationId)
  }
`;
